import {useState} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-bootstrap';
import {UilEdit} from '@iconscout/react-unicons';

export default function AccountDataEditor({title, name, value, handleChangeForm, updateAccountData}) {
  const [edited, setEdited] = useState(false);

  const toggleEdited = () => {
    if (edited) {
      updateAccountData();
    }
    setEdited(!edited);
  };

  return (
    <div className="profile-item">
      <div className="profile-name">{title}</div>
      <div className="profile-info">
        {edited ? (
          <Form>
            <Form.Group className="mb-3" controlId={`account-${name}`}>
              <Form.Control
                type="text"
                aria-label={title}
                placeholder={name}
                name={name}
                value={value}
                onChange={handleChangeForm}
              />
            </Form.Group>
          </Form>
        ) : (
          <span id={name}>{value}</span>
        )}
      </div>
      <div>
        <button
          type="button"
          className="icon-btn"
          aria-label={edited ? `Save ${title}` : `Edit ${title}`}
          onClick={toggleEdited}
        >
          <UilEdit className={edited ? 'blueberry-icon' : ''} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

AccountDataEditor.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChangeForm: PropTypes.func.isRequired,
  updateAccountData: PropTypes.func.isRequired,
};
